function getStore(key) {
    let data;
    try {
        const raw = localStorage.getItem(key);
        data = raw ? JSON.parse(atob(raw)) : {};
    } catch (e) {
        console.log(e);
    }
    return data;
}

function setStore(key, data) {
    try {
        localStorage.setItem(key, btoa(JSON.stringify(data)));
    } catch (e) {
        console.log(e);
        return false;
    }
    return true;
}

function clearStore(key) {
    try {
        localStorage.removeItem(key);
    } catch (e) {
        console.log(e);
        return false;
    }
    return true;
}

export { getStore, setStore, clearStore };